import type { ReactElement } from 'react';
import type { PluginSummary } from './source';
import { PluginCard } from './PluginCard';

export interface PluginListProps {
  label: string;
  items: PluginSummary[];
  onOpen(id: string): void;
  /** Per-id status pill (e.g. installed enabled/disabled). */
  statusFor?(id: string): string | undefined;
  emptyText?: string;
}

export function PluginList({
  label,
  items,
  onOpen,
  statusFor,
  emptyText = 'Nothing here yet.',
}: PluginListProps): ReactElement {
  return (
    <section className="mp-mlist" aria-label={label}>
      {items.length === 0 ? (
        <p className="mp-mlist__empty">{emptyText}</p>
      ) : (
        <ul className="mp-mlist__grid" role="list">
          {items.map((s) => (
            <li key={s.id}>
              <PluginCard summary={s} status={statusFor?.(s.id)} onOpen={onOpen} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
